import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { KioskPatient } from '../kiosk.model';

@Component({
  selector: 'kiosk-patient-card',
  template: require('./kiosk-patient-card.component.html'),
  styles: [require('./kiosk-patient-card.component.scss')],
  changeDetection: ChangeDetectionStrategy.OnPush,
  preserveWhitespaces: false,
})
export class KioskPatientCardComponent {
  @Input() patient: KioskPatient;
}



// WEBPACK FOOTER //
// ../node_modules/angular2-template-loader!./ng2/kiosk/kiosk-patient-card/kiosk-patient-card.component.ts